import type { TOC } from '@ember/component/template-only';
import type { ItemDetailsSignature } from './utils.gts';

/** Card details for music: artist + album */
const MusicDetails: TOC<ItemDetailsSignature> = <template>
  {{#if (artistName @data)}}
    <p class="text-base-content/60 text-sm font-medium">
      {{artistName @data}}
    </p>
  {{/if}}
  {{#if (albumName @data)}}
    <p class="text-base-content/70 text-xs">
      {{albumName @data}}
    </p>
  {{/if}}
</template>;

function artistName(data: Record<string, unknown> | null): string | null {
  const artists = data?.artists as string[] | undefined;
  if (artists && artists.length > 0) {
    return artists.join(', ');
  }
  return (data?.artistName as string) ?? null;
}

function albumName(data: Record<string, unknown> | null): string | null {
  return (data?.albumName ?? data?.collectionName) as string | null;
}

export default MusicDetails;
